module.exports = __webpack_public_path__ + "img/train-category.623e98fa.jpg";